/*
 * <healr-hero> — crossfade slider for the HEALR hero media blocks.
 * Behavior is reimplemented natively (no Timeline/Swiper bundle).
 * Activates only when there is more than one slide; otherwise it's a static hero.
 */
(function () {
  if (customElements.get('healr-hero')) return;

  customElements.define(
    'healr-hero',
    class HealrHero extends HTMLElement {
      constructor() {
        super();
        this.index = 0;
        this.timer = null;
        this.onDotClick = this.onDotClick.bind(this);
      }

      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-healr-hero-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-healr-hero-dot]'));
        this.autoplay = this.dataset.autoplay === 'true';
        this.interval = parseInt(this.dataset.interval, 10) || 6000;

        if (this.slides.length <= 1) return;

        this.dots.forEach((dot) => dot.addEventListener('click', this.onDotClick));
        this.setActive(0);

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.autoplay && !reduceMotion) this.start();

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => {
          if (this.autoplay && !reduceMotion) this.start();
        });
      }

      disconnectedCallback() {
        this.stop();
        this.dots.forEach((dot) => dot.removeEventListener('click', this.onDotClick));
      }

      onDotClick(event) {
        const i = parseInt(event.currentTarget.dataset.healrHeroDot, 10);
        if (!Number.isNaN(i)) {
          this.setActive(i);
          this.restart();
        }
      }

      setActive(i) {
        this.index = (i + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, n) => {
          const active = n === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          const video = slide.querySelector('video');
          if (video) {
            if (active) {
              const p = video.play();
              if (p && p.catch) p.catch(function () {});
            } else {
              video.pause();
            }
          }
        });
        this.dots.forEach((dot, n) => {
          dot.classList.toggle('is-active', n === this.index);
          dot.setAttribute('aria-current', n === this.index ? 'true' : 'false');
        });
      }

      next() {
        this.setActive(this.index + 1);
      }

      start() {
        this.stop();
        this.timer = window.setInterval(() => this.next(), this.interval);
      }

      stop() {
        if (this.timer) {
          window.clearInterval(this.timer);
          this.timer = null;
        }
      }

      restart() {
        if (this.timer) this.start();
      }
    }
  );
})();
